import React from 'react';
import './ToolsButton.css';

interface ToolsButtonProps {
    onClick: () => void;
    disabled?: boolean;
}

const ToolsButton: React.FC<ToolsButtonProps> = ({ onClick, disabled = false }) => {
    return (
        <button
            className="tools-button"
            onClick={onClick}
            disabled={disabled}
            title="Outils et mes traces"
        >
            <span className="tools-icon">🛠️</span>
        </button>
    );
};

export default ToolsButton;
